<div class='w-full'>
  @if (isBusy) {
    <mat-spinner class='absolute top-1/2 left-1/2 z-[1000]'></mat-spinner>
  }
  @if (isZoneSupported) {
    <app-panel title="Zone" icon="layers" [disabled]='!isReady' [tooltip]='tooltip("zone")' data-cy="zone-config-panel">
      <div panel-content>
        <mat-form-field class='w-full skinny-form-4'>
          <mat-select data-cy="set-zone" [(ngModel)]="zone" [disabled]='!isReady'>
            <mat-option [value]='-1' [disabled]='true'>Please select a zone</mat-option>
            @for (item of lightingConfigService.zoneValueArray; track item.id) {
              <mat-option [value]="item.id"> {{item.value}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div footer-content>
        <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetZone()" (updateHandler)="setZone()" dataCy='zone'></app-panel-footer>
      </div>
    </app-panel>
  }
  <app-panel title="Max Light" icon="light_mode" [disabled]='!isReady' [tooltip]='tooltip("maxLight")' data-cy="max-light-config-panel">
    <div panel-content>
      <div class='mr-1'>
        <div class='flex flex-row justify-between'>
          <mat-chip data-cy="lighting-config-max-light-chip" [disabled]='!isReady'>{{maxLight}}</mat-chip>
          @if (indexedMaxLight === 0) {
            <mat-chip class='mx-1' data-cy="lighting-config-max-light-factory-default-chip">Factory Default</mat-chip>
          }
        </div>
        <div class='slider-div'>
          <mat-slider class='config-slider' [min]='1' [max]='31' [step]='1' [disabled]='!isReady'>
            <input aria-label='Max Light Slider' data-cy="max-light-slider-input" matSliderThumb [(ngModel)]='indexedMaxLight'>
          </mat-slider>
        </div>
      </div>
    </div>
    <div footer-content>
      <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetMaxLight()" (updateHandler)="setMaxLight()" dataCy='max-light-level'></app-panel-footer>
    </div>
  </app-panel>
  <app-panel title="Low Light" icon="wb_twilight" [disabled]='!isReady' [tooltip]='tooltip("lowLight")' data-cy="low-light-config-panel">
    <div panel-content>
      <div>
        <div class='flex flex-row justify-between'>
          <mat-chip data-cy="lighting-config-low-light-chip">{{lowLight}}</mat-chip>
          @if (indexedLowLight === 0) {
            <mat-chip class='mx-1' data-cy="lighting-config-low-light-factory-default-chip">Factory Default</mat-chip>
          }
        </div>
        <div class='slider-div'>
          <mat-slider class='config-slider' [min]='1' [max]='31' [step]='1' [disabled]='!isReady'>
            <input aria-label='Low Light Slider' data-cy="low-light-slider-input" matSliderThumb [(ngModel)]='indexedLowLight'>
          </mat-slider>
        </div>
      </div>
    </div>
    <div footer-content>
      <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetLowLight()" (updateHandler)="setLowLight()" dataCy='low-light-level'></app-panel-footer>
    </div>
  </app-panel>
  <app-panel title="Min Light" icon="emoji_objects" [disabled]='!isReady' [tooltip]='tooltip("minLight")' data-cy="min-light-config-panel">
    <div panel-content>
      <div>
        <div class='flex flex-row justify-between'>
          <mat-chip data-cy="lighting-config-min-light-chip">{{minLight}}</mat-chip>
          @if (indexedMinLight === 0) {
            <mat-chip class='mx-1' data-cy="lighting-config-min-light-factory-default-chip">Factory Default</mat-chip>
          }
        </div>
        <div class='slider-div'>
          <mat-slider class='config-slider' [min]='1' [max]='31' [step]='1' [disabled]='!isReady'>
            <input aria-label='Min Light Slider' data-cy="min-light-slider-input" matSliderThumb [(ngModel)]='indexedMinLight'>
          </mat-slider>
        </div>
      </div>
    </div>
    <div footer-content>
      <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetMinLight()" (updateHandler)="setMinLight()" dataCy='min-light-level'></app-panel-footer>
    </div>
  </app-panel>
  <app-panel title="Dwell Time" icon="history_toggle_off" [disabled]='!isReady' [tooltip]='tooltip("dwellTime")' data-cy="dwell-time-config-panel">
    <div panel-content>
      <mat-form-field class='w-full skinny-form-4'>
        <mat-select data-cy="set-dwell-time" [(ngModel)]="dwellTime" [disabled]='!isReady'>
          <mat-option [value]='-1' [disabled]='true'>Please select a dwell time</mat-option>
          @if (dwellTime === 0) {
            <mat-option [value]='0' [disabled]='true'>10 Minutes (Factory Default)</mat-option>
          }
          @for (item of lightingConfigService.dwellTimeValueArray; track item.id) {
            <mat-option [value]="item.id"> {{item.value}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div footer-content>
      <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetDwellTime()" (updateHandler)="setDwellTime()" dataCy='dwell-time'></app-panel-footer>
    </div>
  </app-panel>
  <app-panel [title]="'Low Light Time'" [icon]="'alarm'" [disabled]='!isReady' [tooltip]='tooltip("lowLightTime")' data-cy="low-light-time-config-panel">
    <div panel-content>
      <mat-form-field class='w-full skinny-form-4'>
        <mat-select data-cy="set-low-light-time" [(ngModel)]="lowLightTime" [disabled]='!isReady'>
          <mat-option [value]='-1' [disabled]='true'>Please select a low light time</mat-option>
          @if (lowLightTime === 0) {
            <mat-option [value]='0' [disabled]='true'>10 Minutes (Factory Default)</mat-option>
          }
          @for (item of lightingConfigService.dwellTimeValueArray; track item.id) {
            <mat-option [value]="item.id"> {{item.value}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div footer-content>
      <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetLowLightTime()" (updateHandler)="setLowLightTime()" dataCy='low-light-time'></app-panel-footer>
    </div>
  </app-panel>
   <app-panel [title]="'Scene'" [icon]="'splitscreen_landscape'" [disabled]='!isReady' [tooltip]='tooltip("scene")' data-cy="scene-config-panel">
     <div panel-content>
       <mat-form-field class='w-full skinny-form-4'>
         <mat-select data-cy="set-scene" [(ngModel)]="scene" [disabled]='!isReady'>
           <mat-option [value]='-1' [disabled]='true'>Please select a scene</mat-option>
           @for (item of lightingConfigService.sceneValueArray; track item.id) {
             <mat-option [value]="item.id"> {{item.value}}</mat-option>
           }
         </mat-select>
       </mat-form-field>
     </div>
     <div footer-content>
       <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetScene()" (updateHandler)="setScene()" dataCy='scene'></app-panel-footer>
     </div>
   </app-panel>
   <app-panel [title]="'Personality'" [icon]="'person'" [disabled]='!isReady' [tooltip]='tooltip("personality")' data-cy="personality-config-panel">
     <div panel-content>
       <mat-form-field class='w-full skinny-form-4'>
         <mat-select data-cy="set-personality" [(ngModel)]="personality" [disabled]='!isReady'>
           @for (item of lightingConfigService.personalityValueArray; track item.id) {
             <mat-option [value]="item.id"> {{item.value || item.id}}</mat-option>
           }
         </mat-select>
       </mat-form-field>
     </div>
     <div footer-content>
       <app-panel-footer [disableReset]="isBusy || !isReady" [disableSubmit]='!isReady' (resetHandler)="resetPersonality()" (updateHandler)="setPersonality()" dataCy='personality'></app-panel-footer>
     </div>
   </app-panel>
   @if (isMotionSupported) {
    <app-panel
      [isFeatureAvailable]="'motion-sensitivity-old-ui'"
      [nodeType]="selectedNode?.nodeType"
      [picVersion]="selectedNode?.picVersion"
      [nordicVersion]="selectedNode?.nordicVersion"
      [title]="'Motion Sensitivity'"
      [orIcon]="'motion-sensor'"
      [disabled]='!isReady'
      [tooltip]='tooltip("motionSensitivity")'
      data-cy="motion-sensitivity-old-config-panel">
      <div panel-content>
        <mat-form-field class='w-full skinny-form-4'>
          <mat-select data-cy="set-motion-sensitivity-old" [(ngModel)]="motionSensitivity" [disabled]='!isReady'>
            @for (item of lightingConfigService.oldMotionSensitivityOptions; track item.value) {
              <mat-option [value]="item.value">{{item.label}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div footer-content>
        <app-panel-footer [disableReset]="isBusy || !isReady || !isMotionSupported" [disableSubmit]='!isReady || !isMotionSupported' (resetHandler)="resetMotionSensitivity()" (updateHandler)="setMotionSensitivity()" dataCy='motion-sensitivity-old'></app-panel-footer>
      </div>
    </app-panel>
    <app-panel
      [isFeatureAvailable]="'motion-sensitivity-ui'"
      [nodeType]="selectedNode?.nodeType"
      [picVersion]="selectedNode?.picVersion"
      [nordicVersion]="selectedNode?.nordicVersion"
      [title]="'Motion Sensitivity'"
      [orIcon]="'motion-sensor'"
      [disabled]='!isReady'
      [tooltip]='tooltip("motionSensitivity")'
      data-cy="motion-sensitivity-config-panel">
      <div panel-content>
        <div class='mr-1'>
          <div class='flex flex-row justify-between'>
            <mat-chip data-cy="lighting-config-motion-sensitivity-chip" [disabled]='!isReady'>{{motionSensitivityLabel}}</mat-chip>
          </div>
          <div class='slider-div'>
            <mat-slider class='config-slider' [min]='0' [max]='lightingConfigService.MOTION_SENSITIVITY_VALUES.length - 1' [step]='1' [disabled]='!isReady'>
              <input aria-label='Motion Sensitivity Slider' data-cy="motion-sensitivity-slider-input" matSliderThumb [(ngModel)]='motionSensitivityIndex'>
            </mat-slider>
          </div>
        </div>
      </div>
      <div footer-content>
        <app-panel-footer [disableReset]="isBusy || !isReady || !isMotionSupported" [disableSubmit]='!isReady || !isMotionSupported' (resetHandler)="resetMotionSensitivity()" (updateHandler)="setMotionSensitivity()" dataCy='motion-sensitivity'></app-panel-footer>
      </div>
    </app-panel>
    <app-panel
      [isFeatureAvailable]="'idle-motion-mode'"
      [nodeType]="selectedNode?.nodeType"
      [picVersion]="selectedNode?.picVersion"
      [nordicVersion]="selectedNode?.nordicVersion"
      [title]="'Lower sensitivity when in Standby'"
      [orIcon]="'motion-idle'"
      [disabled]='!isReady'
      [tooltip]='tooltip("motionIdleMode")'
      data-cy="motion-idle-mode-config-panel">
      <div panel-content>
        <div class='flex flex-row items-center gap-3 py-2'>
          <mat-slide-toggle
            data-cy="lighting-config-motion-idle-mode-toggle"
            [(ngModel)]='motionIdleMode'
            [disabled]='!isReady'
            aria-label="Lower sensitivity when in Standby">
            {{motionIdleMode ? 'Enabled' : 'Disabled'}}
          </mat-slide-toggle>
        </div>
      </div>
      <div footer-content>
        <app-panel-footer [disableReset]="isBusy || !isReady || !isMotionSupported" [disableSubmit]='!isReady || !isMotionSupported' (resetHandler)="resetMotionIdleMode()" (updateHandler)="setMotionIdleMode()" dataCy='motion-idle-mode'></app-panel-footer>
      </div>
    </app-panel>
  }
</div>
